import React, { useEffect } from "react";
import ExplainerVideo from "../components/ExplainerVideo";

/**
 * Chrome-less playback page used by /app/backend/scripts/render_explainer.py.
 *
 * Mounts the ExplainerVideo in `recordMode`, which:
 *   - auto-starts playback
 *   - drives the scene timeline from an internal interval (no audio
 *     dependency — headless Chromium often blocks autoplay audio)
 *   - hides the play overlay + controls so the recording is clean
 *
 * The pristine source MP3 is muxed onto the video by ffmpeg afterwards.
 */
export default function ExplainerRecord() {
  useEffect(() => {
    document.body.style.background = "#0b0d12";
    document.body.style.margin = "0";
    window.__explainerReady = true;
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0b0d12",
        padding: 0,
      }}
      data-testid="explainer-record-shell"
    >
      <div style={{ width: "100%", maxWidth: 1240 }}>
        <ExplainerVideo recordMode />
      </div>
    </div>
  );
}
